var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"width":"100%","height":"100%","src":"/static/tool/qt-regularexpression/regularexpression.html","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }